import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, ZapOff, Brain, Droplets } from 'lucide-react';
export function Problem() {
  return <section className="py-24 px-4 bg-offwhite" data-id="element-255">
      <div className="max-w-3xl mx-auto" data-id="element-256">
        <FadeIn data-id="element-257">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-8 text-center" data-id="element-258">
            El Problema: Sobrealimentados pero Desnutridos
          </h2>

          <p className="text-lg text-charcoal/80 leading-relaxed mb-12 text-center" data-id="element-259">
            Vivimos en la era de la sobrealimentación y la desnutrición celular.
            Puedes comer tres veces al día y, sin embargo, estar biológicamente
            "hambriento".
          </p>
        </FadeIn>

        <div className="grid gap-6 sm:grid-cols-3 mb-12" data-id="element-260">
          <FadeIn delay={0.1} data-id="element-261">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-sage/50 h-full" data-id="element-262">
              <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center mb-4 text-forest" data-id="element-263">
                <AlertCircle size={24} data-id="element-264" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-forest" data-id="element-265">
                Estrés Crónico
              </h3>
              <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-266">
                Vacía tus reservas de magnesio, dejándote tenso e incapaz de
                relajarte verdaderamente.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-267">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-sage/50 h-full" data-id="element-268">
              <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center mb-4 text-forest" data-id="element-269">
                <Brain size={24} data-id="element-270" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-forest" data-id="element-271">Luz Azul</h3>
              <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-272">
                Las pantallas constantes agotan tu complejo B, crucial para la
                claridad mental y el enfoque.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-273">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-sage/50 h-full" data-id="element-274">
              <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center mb-4 text-forest" data-id="element-275">
                <Droplets size={24} data-id="element-276" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-forest" data-id="element-277">
                Sudor y Café
              </h3>
              <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-278">
                Eliminan los electrolitos esenciales que mantienen tus neuronas
                encendidas y comunicándose.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-279">
          <div className="bg-amber/10 border-l-4 border-amber p-6 rounded-r-xl" data-id="element-280">
            <div className="flex items-start gap-4" data-id="element-281">
              <ZapOff className="text-amber shrink-0 mt-1" size={24} data-id="element-282" />
              <p className="text-lg text-charcoal/90 leading-relaxed" data-id="element-283">
                Cuando estas brechas nutricionales aparecen, tu cuerpo entra en{' '}
                <strong data-id="element-284">"modo ahorro"</strong>. Tu enfoque desaparece, tu
                paciencia se agota y tu energía se desploma justo cuando más la
                necesitas. Intentar solucionar esto con más cafeína es como
                azotar a un caballo cansado: solo aceleras el colapso final.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}